import ngRedux from 'ng-redux';
import store from './store';

export class NgStore {
  constructor($ngReduxProvider: ngRedux.INgReduxProvider) {
    'ngInject';
    $ngReduxProvider.provideStore(store);
  }
}
